import jwt_decode from "jwt-decode";
import {PlusThemeProvider} from "./PLUS/PlusThemeProvider.tsx";
import {IDPThemeProvider} from "./IDP/IDPThemeProvider.tsx";

export interface ThemeProvider {
    CMSPrefix: string;
    header: {
        Logo: {
            uri: string;
            img: JSX.Element;
        };
    };
    Footer: React.FC;
    uris: {
        other: {
            termsAndConditions: string;
        }
    }
    congrats: {
        ContentContainerUpper: React.FC;
        ContentContainerLower: React.FC;
        BackgroundImage: React.FC;
        primaryCTA: Boolean;
    }
}

export default function useTheme(){
    let serviceType = process.env.REACT_APP_DEFAULT_AZP;
    let referer = new URLSearchParams(document.location.search).get('referer');

    if(!!sessionStorage.getItem('kc_action')){
        let kc_action = jwt_decode(JSON.parse(sessionStorage.getItem('kc_action')).token) as {azp: string}
        if(!!kc_action.azp)
            serviceType = kc_action.azp;
    }
    else if(!!sessionStorage.getItem('kc_tok')){
        let kc_tok = JSON.parse(sessionStorage.getItem('kc_tok'));
        if(!!kc_tok.referer)
            serviceType = kc_tok.referer;
    }
    else if(!!referer && referer === 'ant1gr'){
        serviceType = referer;
    }
    
    console.log("ServiceType: ", serviceType)
    if (serviceType === "ant1gr") {
        return new IDPThemeProvider();
    } else {
        return new PlusThemeProvider();
    }
}